var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useEffect } from 'preact/hooks';
import React, { useState } from 'react';
import { i18nInit } from '../../../util/i18n/config';
import { UserContext } from '../../../context/UserContext';
import { createMemoizedContextData } from '../../../context/Utils';
import { UTMContext } from '../../../util/UTM';
import { MetricContextProvider } from '../../tailwind_clearstep/MetricForm/Context/MetricContextProvider';
import { useSplit } from '../util/Split';
import Conversation from './Conversation';
import { PartnerCustomizationsWrapper } from '../../tailwind_clearstep/Partners/symptom_check/PartnerCustomizationWrapper';
import { TranslationServiceProvider } from '../../../util/i18n/TranslationServiceProvider';
// Need this to be passed in so we can use the "emotion" styling from react-styles
var nonce = window.nonce;
var styleCache = createCache({
    key: 'conversation-emotion-style',
    nonce: nonce,
});
export var ConversationWrapper = function (props) {
    var isProxyUser = props.isProxyUser, utmParams = props.utmParams;
    var userContext = createMemoizedContextData({ isProxyUser: isProxyUser });
    var _a = useState(false), translationsInit = _a[0], setTranslationsInit = _a[1];
    useEffect(function () {
        // render Conversation once translations are loaded
        i18nInit(function () { return setTranslationsInit(true); });
    }, []);
    useSplit(props.id.toString());
    return (React.createElement(CacheProvider, { value: styleCache },
        React.createElement(UTMContext.Provider, { value: utmParams },
            React.createElement(PartnerCustomizationsWrapper, null,
                React.createElement(UserContext.Provider, { value: userContext },
                    React.createElement(MetricContextProvider, null,
                        React.createElement(TranslationServiceProvider, null, translationsInit && React.createElement(Conversation, __assign({}, props)))))))));
};
export default ConversationWrapper;
